/**
 * User's roles in system. The greater the value, the more rights
 */
export enum Role {
	'student',
	'parent',
	'teacher',
	'franchise',
	'master franchise',
	'super franchise',
}
